// @flow
import * as React from 'react';

import { useState } from 'react';

import { withTranslation } from '@i18n';

import type { PropsTime } from './types';

import {
  StyledFlowButtonWrapper,
  StyledFlowButton,
  StyledIconWrapper,
  StyledLabel,
  StyledFlowButtonContainer
} from './styles/flowButton';

const FlowButton = ({
  onTimeSelect, isActive, buttons, t, treatmentPage
}: PropsTime) => {
  const [seeMore, setSeeMore] = useState(false);

  if (!isActive) {
    return null;
  }
  return (
    <StyledFlowButtonWrapper seemore={seeMore}>
      {buttons.map(({ label, icon: Icon, value }) => (
        <StyledFlowButtonContainer key={value} onClick={() => onTimeSelect(value)}>
          <StyledFlowButton>
            <StyledIconWrapper>
              <Icon alt={label} />
            </StyledIconWrapper>
          </StyledFlowButton>
          <StyledLabel>{label}</StyledLabel>
        </StyledFlowButtonContainer>
      ))}
      {!treatmentPage && (
        <StyledFlowButtonContainer onClick={() => setSeeMore(!seeMore)} seemore>
          <StyledLabel seemore>{seeMore ? t('Seeless') : t('Seemore')}</StyledLabel>
        </StyledFlowButtonContainer>
      )}
    </StyledFlowButtonWrapper>
  );
};

FlowButton.getInitialProps = (): {} => ({
  namespacesRequired: ['HowItWorksScreen']
});

export default withTranslation('HowItWorksScreen')(FlowButton);
